// extracted by mini-css-extract-plugin
module.exports = {"chipsGroup":"_2c1XawjQPg_services-landings"};